/*
  Zugo - musteri yorumlari seridi.

  Marka vitrinindeki serit ile ayni yaklasim: kaydirmayi tarayici yapar
  (`scroll-snap`), oklar ve noktalar sadece tetikler. Kart sayisi ekran
  genisligine gore degistigi icin sayfa sayisi olcumle bulunur.
*/
class ZugoReviewsSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    this.dots = this.querySelector('[data-dots]');
    this.arrows = [...this.querySelectorAll('[data-yon]')];
    if (!this.track) return;

    this.onScroll = this.debounce(() => this.durumGuncelle(), 90);
    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    this.arrows.forEach((b) =>
      b.addEventListener('click', () => this.kaydir(b.dataset.yon === 'sonraki' ? 1 : -1))
    );

    if (window.ResizeObserver) {
      this.gozlemci = new ResizeObserver(this.debounce(() => this.noktalariKur(), 120));
      this.gozlemci.observe(this.track);
    }

    this.noktalariKur();
  }

  disconnectedCallback() {
    this.gozlemci?.disconnect();
    this.track?.removeEventListener('scroll', this.onScroll);
  }

  get sayfaGenisligi() {
    return this.track.clientWidth;
  }

  get sayfaSayisi() {
    return Math.max(1, Math.round(this.track.scrollWidth / this.sayfaGenisligi));
  }

  noktalariKur() {
    const adet = this.sayfaSayisi;
    const kontroller = this.querySelector('.zugo-reviews__controls');

    if (adet < 2) {
      if (kontroller) kontroller.hidden = true;
      return;
    }
    if (kontroller) kontroller.hidden = false;

    if (this.dots && this.dots.children.length !== adet) {
      this.dots.innerHTML = '';
      for (let i = 0; i < adet; i += 1) {
        const n = document.createElement('button');
        n.type = 'button';
        n.className = 'zugo-reviews__dot';
        n.setAttribute('aria-label', `${i + 1}`);
        n.addEventListener('click', () =>
          this.track.scrollTo({ left: i * this.sayfaGenisligi, behavior: 'smooth' })
        );
        this.dots.appendChild(n);
      }
    }
    this.durumGuncelle();
  }

  durumGuncelle() {
    const aktif = Math.round(this.track.scrollLeft / this.sayfaGenisligi);
    if (this.dots) {
      [...this.dots.children].forEach((d, i) =>
        d.setAttribute('aria-current', i === aktif ? 'true' : 'false')
      );
    }
    const son = this.sayfaSayisi - 1;
    this.arrows.forEach((b) => {
      b.disabled = b.dataset.yon === 'sonraki' ? aktif >= son : aktif <= 0;
    });
  }

  kaydir(yon) {
    this.track.scrollBy({ left: yon * this.sayfaGenisligi, behavior: 'smooth' });
  }

  debounce(fn, ms) {
    let t;
    return (...a) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, a), ms);
    };
  }
}

if (!customElements.get('zugo-reviews-slider')) {
  customElements.define('zugo-reviews-slider', ZugoReviewsSlider);
}
